import HamburgerMenu from '../../src/legacy/HamburgerMenu';
export default HamburgerMenu;
